module.exports = __webpack_public_path__ + "6930e3aec514a461103711c3311b7c2c.png";